import PiDeleteButton from "../../../components/PiDeleteButton";
import NodeActorDropdown from "../components/NodeActorDropdown";
import LookatTargetDropdown from "./LookatTargetDropdown";

export default function LookatEntryCard(props: {
  nodeId: string;
  index: number;
  total: number;
  hasErrors?: boolean;
  sourceNpcId: string;
  targetId: string;
  onActorChange: (sourceNpcId: string) => void;
  onTargetChange: (targetId: string) => void;
  onDelete: () => void;
}) {
  const indexLabel = String(props.index + 1).padStart(2, "0");

  return (
    <div
      className={`w-full rounded-[5px] p-[8px] border ${
        props.hasErrors
          ? "bg-creator-error-washed border-creator-error/40"
          : "bg-creator-primary-background border-creator-border/60 dark:border-[rgba(58,196,255,0.7)]"
      }`}
      onScroll={(e) => e.stopPropagation()}
    >
      <div className="w-full flex items-center justify-between h-[20px] mb-[10px]">
        <div className="text-[12px] font-semibold text-creator-text-soft tracking-[0.08em]">
          Lookat {indexLabel}
        </div>
        {props.total > 1 && (
          <div className="h-[20px] w-[20px] shrink-0">
            <PiDeleteButton onClick={props.onDelete} size="small" />
          </div>
        )}
      </div>
      <div className="w-full flex flex-col gap-[12px]">
        <NodeActorDropdown
          label="Actor"
          selectedActorId={props.sourceNpcId}
          onClick={props.onActorChange}
        />
        <LookatTargetDropdown
          label="Target"
          nodeId={props.nodeId}
          targetIndex={props.index}
          selectedTargetId={props.targetId}
          onClick={props.onTargetChange}
        />
      </div>
    </div>
  );
}
